import React, { useState, useEffect, useRef } from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton
 } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

const EditDescriptionModal = ({ classes, isModalOpen, onUpdate, onCancel, value }) => {
  const [textInputValue, setTextInputValue] = useState('');
  const textFieldRef = useRef();
  const exceedsLength = textInputValue?.length > 100;

  useEffect(() => {
    setTextInputValue(value);
  }, [value]);

  const handleFocus = (event) => {
    event.preventDefault();
    const lengthOfInput = event.target.value.length;
    return event.target.setSelectionRange(lengthOfInput, lengthOfInput);
  }

  const handleKeyDown = (event) => {
    // Trigger update method when user press 'enter'
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation()
      if (!exceedsLength) handleUpdate();
    }
  }

  const handleChange = (event) => {
    setTextInputValue(event.target.value);
  }

  const handleUpdate = () => {
    onUpdate(textInputValue);
    onCancel();
  }

  const handleCancel = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setTextInputValue(value); // set back to user's untouched notes value 
    onCancel(); // close modal
  }

  return (
    <Dialog onClose={handleCancel} open={isModalOpen} maxWidth='sm' fullWidth>
      <DialogTitle>
        Edit Module Description
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleCancel}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <TextField
          id="outlined-multiline-flexible"
          classes={{ root: classes.textFieldRoot }}
          multiline
          rowsMax="5"
          value={textInputValue}
          onChange={handleChange}
          autoFocus
          onFocus={handleFocus}
          inputRef={textFieldRef}
          onKeyDown={handleKeyDown}
          error={exceedsLength}
          helperText={exceedsLength ? 'Length of description cannot exceed 100 characters' : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleUpdate} disabled={exceedsLength || textInputValue === value} variant="contained" color="primary">Update</Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = theme => ({
  textFieldRoot: {
    width: '100%'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

export default compose(
  withStyles(styles)
)(EditDescriptionModal);